// Listeners helper
export class Listeners {
  constructor() {
    this.entries = [];
  }

  add(element, event, fn) {
    if (typeof element === 'string') {
      const elements = document.querySelectorAll(element);
      console.log(element, elements);
      elements.forEach((el) => {
        this.entries.push({
          element: el,
          event,
          fn,
        });
        el.addEventListener(event, fn);
      });
    } else {
      this.entries.push({
        element,
        event,
        fn,
      });
      element.addEventListener(event, fn);
    }
  }

  remove(element, event) {
    this.entries = this.entries.filter((listener) => {
      if (listener.element === element && listener.event === event) {
        listener.element.removeEventListener(listener.event, listener.fn);
        return false;
      }
    });
  }

  removeAll() {
    this.entries = this.entries.filter((listener) => {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  }
}

export function loadScript(src, onLoadSuccessCallback, onLoadErrorCallback) {
  if (!src) {       
    if (typeof Bugsnag !== 'undefined') Bugsnag.notify(new Error('Error: missing src'));
    return console.warn('Error: missing src');
  }

  // Check if the script is already loaded
  if (document.querySelector('script[src="' + src + '"]')) {
    // Script already loaded...
    console.warn("Script Already Loaded. Skipping: ", src);
    onLoadSuccessCallback();
  } else {
    // Script not already leaded; load script...
    // Create script tag
    const js = document.createElement("script");
    js.src = src;
    if (src.includes('zdassets')) js.id = 'ze-snippet';
    js.setAttribute("async", "");

    // Setup success callback
    if (onLoadSuccessCallback) {
      js.onload = onLoadSuccessCallback;
    }

    // Setup error callback
    if (onLoadErrorCallback) {
      js.onerror = onLoadErrorCallback;
    }

    // Add the script tag to <head>
    document.head.appendChild(js);
  }
}

export async function loadCSS(src, onLoadSuccessCallback, onLoadErrorCallback) {
  if (!src) {       
    if (typeof Bugsnag !== 'undefined') Bugsnag.notify(new Error('Error: missing src'));
    return console.warn('Error: missing src');
  }

  // Check if the script is already loaded
  if (document.querySelector('link[href="' + src + '"]')) {
    // Script already loaded...
    console.warn("CSS Already Loaded. Skipping: ", src);
    onLoadSuccessCallback();
  } else {
    // Script not already leaded; load script...
    const head = document.getElementsByTagName('HEAD')[0];
    const link = document.createElement('link');

    // set the attributes for link element
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = src;

    // Append link element to HTML head
    head.appendChild(link);

    // Setup success callback
    if (onLoadSuccessCallback) {
      link.onload = onLoadSuccessCallback;
    }

    // Setup error callback
    if (onLoadErrorCallback) {
      link.onerror = onLoadErrorCallback;
    }
  }
}

export function ifIntersectionObserverSupported() {
  return ('IntersectionObserver' in window);
  // if (!('IntersectionObserver' in window) &&
  //   !('IntersectionObserverEntry' in window) &&
  //   !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) return console.warn('IntersectionObserver not supported');
}

export function onSortGoTo(target, callback, behavior = 'smooth') {
  const onSortScrollTo = target || document.querySelector('#onSortScrollTo');
  const siteHeader = document.querySelector('.site-header');
  if (!onSortScrollTo || !siteHeader) return;

  const requestedTop = Math.floor(window.scrollY + (onSortScrollTo.getBoundingClientRect().top - siteHeader.getBoundingClientRect().height));
  const onScroll = () => {
    if (Math.floor(window.scrollY) === requestedTop) {
      window.removeEventListener('scroll', onScroll);

      const checkRequestTop = Math.floor(window.scrollY + (onSortScrollTo.getBoundingClientRect().top - siteHeader.getBoundingClientRect().height));
      if (requestedTop === checkRequestTop) return;

      window.scrollTo({
        top: checkRequestTop, 
        behavior
      });
    }
  }

  window.addEventListener('scroll', onScroll);

  window.scrollTo({
    top: window.scrollY + (onSortScrollTo.getBoundingClientRect().top - siteHeader.getBoundingClientRect().height), 
    behavior
  });
}

// export function fadeIn(elem) {
//   const current = Number(getComputedStyle(elem).opacity);
//   if (current >= 1) return;

//   elem.style.opacity = current + 0.05;
//   setTimeout(function () {
//     fadeIn(elem);
//   }, 10);
// }

// export function fadeOut(elem) {
//   const current = Number(getComputedStyle(elem).opacity);
//   if (current <= 0) return;

//   elem.style.opacity = current - 0.05;
//   setTimeout(function () {
//     fadeOut(elem);
//   }, 10);
// }

// if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
//   module.exports = sliderArrows;
//   module.exports = sliderDots;
//   module.exports = sliderAutoPlay;
// } else {
//   window.sliderArrows = sliderArrows;
//   window.sliderDots = sliderDots;
//   window.sliderAutoPlay = sliderAutoPlay;
// }

export function stripHtml(string) {
  if (typeof string === 'string' || string instanceof String) {
    const doc = new DOMParser().parseFromString(string, 'text/html');
    return doc.body.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ') || '';
  } else {
    return string.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ') || '';
  }
}

export function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

export function throttle(fn, delay = 300) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = (amount, format = window.Shopify.money_format) => {
  const formatNumber = (num, decimals = 2, thousandsSep = ',', decimalSep = '.') => {
      if (isNaN(num) || num == null) return '0';

      num = (num / 100).toFixed(decimals);
      const [intPart, decimalPart] = num.split('.');

      return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep) + (decimalPart ? decimalSep + decimalPart : '');
  };

  if (typeof amount === 'string') amount = amount.replace('.', '');
  
  const formatTypes = {
      amount: () => formatNumber(amount, 2),
      amount_no_decimals: () => formatNumber(amount, 0),
      amount_with_comma_separator: () => formatNumber(amount, 2, '.', ','),
      amount_with_space_separator: () => formatNumber(amount, 2, ' ', ','),
      amount_with_period_and_space_separator: () => formatNumber(amount, 2, ' ', '.'),
      amount_no_decimals_with_comma_separator: () => formatNumber(amount, 0, '.', ','),
      amount_no_decimals_with_space_separator: () => formatNumber(amount, 0, ' '),
      amount_with_apostrophe_separator: () => formatNumber(amount, 2, '\'', '.'),
  };

  const formatKey = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1];
  return format.replace(/\{\{\s*\w+\s*\}\}/, formatTypes[formatKey] ? formatTypes[formatKey]() : '0');
};

export function formatMoney(value, format = 'amount') {
  if (window.Shopify) {
    const inFrontSymbols = '£$€';
    const symbol = window.Shopify.currency.symbol;
    const formatCustom = (inFrontSymbols.includes(symbol)) ? `${symbol}{{${format}}}` : `{{${format}}} ${symbol}`;
    return window.Shopify.formatMoney(value, formatCustom);
  }

  return value;
}

export const getSiblings = (elm, withTextNodes) => {
  if( !elm || !elm.parentNode ) return
  
  const siblings = [...elm.parentNode[withTextNodes ? 'childNodes' : 'children']];
  const idx = siblings.indexOf(elm);
  
  siblings.before = siblings.slice(0, idx);
  siblings.after = siblings.slice(idx + 1);
  
  return siblings
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  const name = cname + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteCookie(cname) {
  document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export function hasCookie(cname) {
  return getCookie(cname) !== "";
}
window.Listeners = Listeners;
